import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

const CVR_DETAIL = "cvr_compliance";

/**
 * Tracks the CVR Compliance page view on load.
 * page_category: action_report, page_detail: list_view_{YYYYMM}, page_section: cvr_compliance
 */
export const cvrPageViewTrack = (period: string) => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", CVR_DETAIL, TEALIUM.CATEGORY.ACTION_REPORT, `list_view_${period}`, "");
};

/**
 * Tracks click on the customize KPI button (filter icon).
 * click_action: customize_KPI, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "customize_KPI",
  );
};

/**
 * Tracks cancel action in the KPI selector modal.
 * click_action: cancel_customize_KPI, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "cancel_customize_KPI",
  );
};

/**
 * Tracks apply action in the KPI selector modal.
 * click_action: apply_customize_KPI, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "apply_customize_KPI",
  );
};

/**
 * Tracks sort ascending click.
 * click_action: sort_ascending, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrSortAscendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "sort_ascending",
  );
};

/**
 * Tracks sort descending click.
 * click_action: sort_descending, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrSortDescendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "sort_descending",
  );
};

/**
 * Tracks info icon click.
 * click_action: info, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrInfoTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "info",
  );
};

/**
 * Tracks export button click.
 * click_action: export, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "export",
  );
};

/**
 * Tracks ABO profile click.
 * click_action: profile, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "profile",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 * click_action: add_to_watchlist, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 * click_action: remove_from_watchlist, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "remove_from_watchlist",
  );
};

/**
 * Tracks phone icon click.
 * click_action: phone_icon, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "phone_icon",
  );
};

/**
 * Tracks message icon click.
 * click_action: message_icon, click_category: action_report, click_detail: cvr_compliance
 */
export const cvrMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CVR_DETAIL,
    "message_icon",
  );
};
